import { Component, Input } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MbConstants } from '../../../../shared/mb-constants'

@Component({
  selector: 'mb-submit-order-term-condition',
  templateUrl: './mb-submit-order-term-condition.component.html',
  styleUrls: ['./mb-submit-order-term-condition.component.scss']
})
export class MbSubmitOrderTermConditionComponent {

  constants = MbConstants
  termsConditionsForm = new UntypedFormGroup({
    termsAndConditions: new UntypedFormControl('', [Validators.requiredTrue]),
  })
  termsOfUseForm = new UntypedFormGroup({
    termsOfUse: new UntypedFormControl('', [Validators.requiredTrue]),
  })

  @Input() isTypeACheckout: boolean | undefined
}
